module.exports = __webpack_public_path__ + "img/applogo.f6e3ed1e.png";